import { Color, Flex, Icon, Text } from '@billy/design-system'
import numeral from 'numeral'
import React, { useRef, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { useOnClickOutside } from '../../../../hooks'
import { SpecificState } from '../../../../types/reduxSaga-deprecated'
import { reactClass } from '../../../../utils'
import { selectDifferenceType } from '../../action-creators'
import { bankReconciliationDifferenceTypeTKeys } from '../../constants/bankReconciliationDifferenceTypeTKeys'
import { Difference, DifferenceType } from '../../types'
import * as Styled from './styles'

export type MatchDifferenceProps = {
  difference: Difference
  matchId: string
}

export const MatchDifference = ({ difference, matchId, ...rest }: MatchDifferenceProps) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [isOpen, setIsOpen] = useState<boolean>(false)

  const bankLineMatches = useSelector((state: SpecificState) => state.bankReconciliation.bankLineMatches)
  const buttonRef = useRef<HTMLDivElement | null>(null)

  const bankLineMatch = bankLineMatches.find((match) => match.id === matchId)
  const differenceTypeSet = bankLineMatch?.differenceType

  const { amount, differenceAmount } = difference

  useOnClickOutside(buttonRef, () => setIsOpen(false))

  const handleSelectDifferenceType = (type: DifferenceType) => {
    dispatch(selectDifferenceType({ type, matchId }))
    setIsOpen(false)
  }

  const formatAmount = (amount: number) => numeral(amount).format('0,0[.]00')

  return (
    <Styled.MatchDifferenceContainer
      onClick={() => setIsOpen(!isOpen)}
      className={reactClass('match-difference')}
      ref={buttonRef}
    >
      <Styled.MatchDifferenceSaldo differenceTypeSet={!!differenceTypeSet}>
        <div>
          {differenceTypeSet ? (
            t(bankReconciliationDifferenceTypeTKeys[differenceTypeSet]) +
            `: ${formatAmount(differenceAmount ?? amount)} DKK`
          ) : (
            <Trans
              i18nKey="bankreconciliation.match.difference"
              values={{
                diff: formatAmount(differenceAmount ?? amount),
              }}
            >
              Book <strong>{formatAmount(differenceAmount ?? amount)} DKK</strong> as
            </Trans>
          )}
        </div>

        <Icon icon="chevronDown" />
      </Styled.MatchDifferenceSaldo>
      <Styled.SaldoOverlay isOpen={isOpen}>
        <Flex flexDirection="column">
          {difference.types.map((type) => (
            <Text
              as="span"
              key={type}
              onClick={() => handleSelectDifferenceType(type)}
              color={Color.Green700}
              weight="medium"
              variant="bodySM"
            >
              {t(`bankreconciliation.difference_type.${type}`)}
            </Text>
          ))}
        </Flex>
      </Styled.SaldoOverlay>
    </Styled.MatchDifferenceContainer>
  )
}
